import { format } from 'date-fns';
import { APIError } from '../errors/APIError';
import { useAPIMutation } from '../useAPIProvider';

export interface submitLeaverRequestArgs {
  customerName: string;
  fullName: string;
  personalEmail: string;
  workEmail?: string;
  mobileNumber: string;
  devicesToBeCollected: string[];
  collectionAddress: string;
  canPrintLabel?: boolean;
  expediteCollection?: boolean;
  targetDate: Date;
  notes?: string;
}

export const useSubmitLeaverRequest = () => {
  return useAPIMutation(client => {
    return async (args: submitLeaverRequestArgs) => {
      const response = await client.management.submitLeaverRequest({
        body: {
          customerName: args.customerName,
          fullName: args.fullName,
          personalEmail: args.personalEmail,
          workEmail: args.workEmail,
          mobileNumber: args.mobileNumber,
          devicesToBeCollected: args.devicesToBeCollected,
          collectionAddress: args.collectionAddress,
          canPrintLabel: args.canPrintLabel || false,
          expediteCollection: args.expediteCollection || false,
          targetDate: format(args.targetDate, 'yyyy-MM-dd'),
          notes: args.notes
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body;
    };
  });
};

export interface submitWarrantyRequestArgs {
  customerName: string;
  modelAndManufacturer: string;
  serialNumber: string;
  userFullName: string;
  userAddress: string;
  workEmailAddress: string;
  mobileNumber: string;
  canPrintLabel?: boolean;
  notes?: string;
}

export const useSubmitWarrantyRequest = () => {
  return useAPIMutation(client => {
    return async (args: submitWarrantyRequestArgs) => {
      const response = await client.management.submitWarrantyRequest({
        body: {
          customerName: args.customerName,
          modelAndManufacturer: args.modelAndManufacturer,
          serialNumber: args.serialNumber,
          userFullName: args.userFullName,
          userAddress: args.userAddress,
          workEmailAddress: args.workEmailAddress,
          mobileNumber: args.mobileNumber,
          canPrintLabel: args.canPrintLabel || false,
          notes: args.notes
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body;
    };
  });
};

export interface submitInvoiceRequestArgs {
  customerName: string;
}

export const useSubmitInvoiceRequest = () => {
  return useAPIMutation(client => {
    return async (args: submitInvoiceRequestArgs) => {
      const response = await client.management.submitInvoiceRequest({
        body: {
          customerName: args.customerName
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body;
    };
  });
};

export interface submitStockProvisionRequestArgs {
  customerName: string;
  bundle?: string;
  customProducts?: { name: string; quantity: number; sku: string }[];
  userFullName: string;
  userAddress: string;
  workEmailAddress: string;
  personalEmailAddress?: string;
  mobileNumber: string;
  notes?: string;
}

export const useSubmitStockProvisionRequest = () => {
  return useAPIMutation(client => {
    return async (args: submitStockProvisionRequestArgs) => {
      const response = await client.management.submitStockProvisionRequest({
        body: {
          customerName: args.customerName,
          bundle: args.bundle,
          products: args.customProducts || [],
          userFullName: args.userFullName,
          userAddress: args.userAddress,
          workEmailAddress: args.workEmailAddress,
          personalEmailAddress: args.personalEmailAddress,
          mobileNumber: args.mobileNumber,
          notes: args.notes
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body;
    };
  });
};

export interface submitStockReportingRequestArgs {
  customerName: string;
}

export const useSubmitStockReportingRequest = () => {
  return useAPIMutation(client => {
    return async (args: submitStockReportingRequestArgs) => {
      const response = await client.management.submitStockReportingRequest({
        body: {
          customerName: args.customerName
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body;
    };
  });
};
